import { APPLICATION_CODES } from './applications'

function roleCodes(suffix: string) {
  return APPLICATION_CODES.map((code) => `${code}_${suffix}`)
}

const SUPER_ADMIN_CODES = roleCodes('super_admin')
const ADMIN_CODES = roleCodes('admin')
const EXAMINER_CODES = roleCodes('examiner')
const SUPPORT_CODES = roleCodes('support')

export const ROLE_GROUPS = {
  ADMIN_PANEL: [...SUPER_ADMIN_CODES, ...ADMIN_CODES, ...EXAMINER_CODES, ...SUPPORT_CODES],
  MANAGE_PANEL: [...SUPER_ADMIN_CODES, ...ADMIN_CODES, ...EXAMINER_CODES],
  EXAMINERS_PANEL: [...SUPER_ADMIN_CODES, ...ADMIN_CODES, ...EXAMINER_CODES],
  ADMINS: [...SUPER_ADMIN_CODES, ...ADMIN_CODES],
  SUPER_ADMIN: [...SUPER_ADMIN_CODES],
  STAFF: [...SUPER_ADMIN_CODES, ...ADMIN_CODES, ...EXAMINER_CODES, ...SUPPORT_CODES],
  QUESTION_UPLOADERS: [...SUPER_ADMIN_CODES, ...ADMIN_CODES, ...EXAMINER_CODES],
  LEARNERS: ['learn_student', 'learn_teacher', 'learn_parent'],
} as const

export type RoleGroupKey = keyof typeof ROLE_GROUPS
